export enum DeviceTreeNodeTypeEnum {
    /**Folder */
    Folder = 0,
    /**Device */
    Device = 1,
}
